import { render, staticRenderFns } from "./BigMenu.vue?vue&type=template&id=d8d78510&"
import script from "./BigMenu.vue?vue&type=script&lang=js&"
export * from "./BigMenu.vue?vue&type=script&lang=js&"
import style0 from "./BigMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports